export default {
  hasTransparentNav: false,
  hasRebateCallout: true,
  metadata: {
    title: 'Styleguide',
    description: 'Dinner Spinner',
    type: 'website'
  },
  title: 'The Styleguide',
  className: 'styleguide',
  content: ''
};
